export enum PurchaseOrderSearchCategory {
  SUPPLIER = "supplier",
  PRODUCT = "product",
}
